module.exports = __webpack_public_path__ + "images/ap-screen-icon-e4bd9cd2.svg";